<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <bookmarks />
    </div>

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <div
        v-show="metaBatida"
        style="margin-right: 50px"
        class="apply-job-package bg-light-success rounded"
      >
        <div style="margin-right: 5px; margin-left: 5px">
          <h2 class="d-inline mr-25">
            IRRUUHHH!!!🎉META BATIDA🥳
          </h2>
        </div>
      </div>
      <faturamento-mes-dropdown />
      <dark-Toggler class="d-none d-lg-block" />

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ user }}
            </p>
            <span class="user-status">{{ funcao }}</span>
          </div>
          <b-avatar
            v-if="userPhoto"
            size="40"
            variant="light-primary"
            badge
            :src="userPhoto"
            class="badge-minimal"
            badge-variant="success"
          />
          <b-avatar
            v-else
            size="40"
            variant="light-primary"
            badge
            :text="getInitials(user)"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          :to="{ name: 'configuracoes' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>Configurações</span>
        </b-dropdown-item>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Bookmarks from '@core/layouts/components/app-navbar/components/Bookmarks.vue'
import FaturamentoMesDropdown from '@core/layouts/components/app-navbar/components/FaturamentoMesDropdown.vue'
import axios from '@/../axios-auth'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,

    // Navbar Components
    FaturamentoMesDropdown,
    DarkToggler,
    Bookmarks,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      metaBatida: false,
      user: '',
      userId: null,
      funcao: '',
      userPhoto: null,
    }
  },
  async created() {
    this.user = localStorage.getItem('userName')
    this.userId = localStorage.getItem('userId')
    this.funcao = localStorage.getItem('funcao')

    // totalFaturamento
    axios.get('api/v1/dashboard/faturamento/mensal', {
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        accept: 'application/json',
      },
    }).then(res => {
      if (res.data.dados[0].total_faturamento > 800000) {
        this.metaBatida = true
      }
    })

    // FOTO DE PERFIL
    await axios.get(`api/v1/users/exibirFoto/${this.userId}`, {
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        accept: 'application/json',
      },
    }).then(res => {
      this.userPhoto = res.data.dados.image
    })
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>
